import React from 'react';
import { Helmet } from 'react-helmet';
import { Layout } from 'antd';
import { injectIntl, WrappedComponentProps, FormattedMessage } from 'react-intl';
import Breadcrumbs from '../../components/LayoutComponents/Breadcrumbs';
import ImportApplicationsForm from '../../components/CbsComponents/Imports/ImportApplicationsForm';

const ImportApplications: React.FC<WrappedComponentProps> = ({ intl }) => {
  const breadcrumbs = [
    {
      title: 'menu.imports',
      href: '#',
    },
    {
      title: 'menu.importApplications',
      href: `/import/applications`,
    },
  ];
  return (
    <Layout.Content style={{ height: '100%', position: 'relative' }}>
      <Helmet title={intl.formatMessage({ id: 'menu.importApplications' })} />
      <div className="utils__content">
        <div style={{ marginBottom: '20px' }}>
          <div className="page-title">
            <FormattedMessage id="menu.imports" />
          </div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
        <ImportApplicationsForm />
      </div>
    </Layout.Content>
  );
};

export default injectIntl(ImportApplications);
